import { render, staticRenderFns } from "./supplement-icons.vue?vue&type=template&id=20850945&scoped=true"
import script from "./supplement-icons.vue?vue&type=script&lang=js"
export * from "./supplement-icons.vue?vue&type=script&lang=js"
import style0 from "./supplement-icons.vue?vue&type=style&index=0&id=20850945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20850945",
  null
  
)

export default component.exports